import { useState } from 'react';
import type { FormEvent } from 'react';

const NEWSLETTER_ADDR = 'https://readdy.ai/api/form/dagnrghtto0ceqqni1b0';

const quick = [
  { label: '今日热瓜', href: '#trending' },
  { label: '表情包仓库', href: '#gallery' },
  { label: '段子神评论', href: '#jokes' },
  { label: '高频问答', href: '#faq' },
  { label: '认识我们', href: '#about' },
  { label: '投稿 / 求图', href: '#contact' },
];

const topics = [
  { label: '打工人摸鱼', href: '#gallery' },
  { label: '宠物卖萌', href: '#gallery' },
  { label: '恋爱日常', href: '#gallery' },
  { label: '生活吐槽', href: '#gallery' },
  { label: '追剧上头', href: '#gallery' },
  { label: '游戏翻车', href: '#gallery' },
];

export default function Footer() {
  const [state, setState] = useState<'idle' | 'ok' | 'err'>('idle');
  const [tip, setTip] = useState('');

  const onSubscribe = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = String(fd.get('website_alt') || '').trim();
    if (honeypot) {
      setState('ok');
      setTip('订阅成功，新鲜热梗每天准时送达！');
      form.reset();
      return;
    }
    fd.delete('website_alt');
    try {
      const res = await fetch(NEWSLETTER_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fd as unknown as Record<string, string>),
      });
      const responseText = await res.text();
      let parsed: Record<string, any> | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || '';
      const ok = res.ok && parsed?.code === 'OK' && !/spam/i.test(responseText + serverMsg);
      if (ok) {
        setState('ok');
        setTip('订阅成功，新鲜热梗每天准时送达！');
        form.reset();
      } else {
        setState('err');
        setTip(/spam/i.test(responseText + serverMsg) ? '系统检测到疑似垃圾请求，请稍后再试。' : serverMsg || '订阅失败，请稍后再试。');
      }
    } catch {
      setState('err');
      setTip('网络开小差了，订阅没成功，稍后再试吧。');
    }
  };

  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 md:px-6 md:grid-cols-2 lg:grid-cols-[1.3fr_0.8fr_0.8fr_1.2fr]">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-background-50/10 text-2xl">🍉</span>
            <span className="font-heading text-2xl">每日看瓜</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-accent-100/85">
            热门事件表情包、梗图、段子与神评论的在线仓库。存图发群、摸鱼整活，每天都有新鲜瓜可看。
          </p>
          <div className="mt-5 flex items-center gap-2.5">
            {['ri-wechat-fill', 'ri-qq-fill', 'ri-weibo-fill', 'ri-bilibili-fill'].map((ic) => (
              <a key={ic} href="#contact" aria-label="联系我们" className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/10 text-lg transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className={ic}></i>
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-label text-sm font-bold tracking-wide text-accent-200">快速导航</h3>
          <ul className="mt-4 space-y-2.5">
            {quick.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="text-sm text-accent-50/90 transition-colors hover:text-background-50">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-label text-sm font-bold tracking-wide text-accent-200">热门分类</h3>
          <ul className="mt-4 space-y-2.5">
            {topics.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="text-sm text-accent-50/90 transition-colors hover:text-background-50">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-label text-sm font-bold tracking-wide text-accent-200">每日热梗订阅</h3>
          <p className="mt-4 text-sm text-accent-100/85">订阅后每天一睁眼，热门表情包与神评直接送到邮箱，绝不让你错过瓜。</p>
          <form onSubmit={onSubscribe} data-readdy-form="newsletter" className="mt-4 flex flex-col gap-2 sm:flex-row">
            <label className="sr-only" htmlFor="nl-email">邮箱地址</label>
            <input
              id="nl-email"
              name="email"
              type="email"
              required
              placeholder="输入邮箱订阅"
              className="w-full rounded-full border border-accent-700 bg-accent-950/40 px-5 py-3 text-sm text-background-50 outline-none transition-colors placeholder:text-accent-300 focus:border-accent-400"
            />
            <button type="submit" className="whitespace-nowrap rounded-full bg-secondary-500 px-5 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-secondary-600">
              订阅
            </button>
            <input className="field-honeypot" type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </form>
          {state !== 'idle' && <p className="mt-3 flex items-start gap-1.5 text-xs text-accent-100">{state === 'ok' ? <i className="ri-checkbox-circle-fill"></i> : <i className="ri-error-warning-fill"></i>}{tip}</p>}
        </div>
      </div>

      <div className="border-t border-accent-800">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-center text-xs text-accent-300 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 每日看瓜 · 梗图·段子·神评论在线仓库</p>
          <p>仅供娱乐分享，尊重原创与版权 · 快乐吃瓜，理性围观</p>
        </div>
      </div>
    </footer>
  );
}